import PropTypes from 'prop-types';
import React from 'react';
import { Record } from 'immutable';

import t from '../../lib/I18n';

import ValidatedField from '../form/ValidatedField';


export default function CustomerEmail (props) {
    return (
        <ValidatedField type="email"
                        id={ props.field }
                        labelClassName="sr-only"
                        standalone
                        { ...props } />
    );
}


CustomerEmail.propTypes = {
    field: PropTypes.string.isRequired,
    form: PropTypes.instanceOf(Record).isRequired,
    label: PropTypes.any,
    placeholder: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    validation: PropTypes.object,
    visited: PropTypes.bool,
    disabled: PropTypes.bool,
    required: PropTypes.bool
};

CustomerEmail.defaultProps = {
    field: 'email',
    label: t('customerdetails.confirmemail'),
    placeholder: t('customerdetails.email'),
    validation: null,
    visited: false,
    disabled: false,
    required: true
};



// WEBPACK FOOTER //
// ./src/components/customer/Email.js